var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPersona(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.34638 12.2963C11.7361 12.2963 14.4945 9.53833 14.4945 6.14814C14.4945 2.75796 11.7366 0 8.34638 0C4.9562 0 2.19824 2.75796 2.19824 6.14814C2.19824 9.53789 4.9562 12.2963 8.34638 12.2963ZM8.34607 1.78477C10.7516 1.78477 12.709 3.74221 12.709 6.14817C12.709 8.55367 10.7516 10.5111 8.34607 10.5111C5.9401 10.5111 3.98266 8.55367 3.98266 6.14817C3.98266 3.74221 5.9401 1.78477 8.34607 1.78477ZM2.05679 22H0.000869751V19.468C0.000869751 18.043 0.468164 16.6918 1.35258 15.5604C2.57165 14.001 4.39763 13.1065 6.36237 13.1065H10.3324C11.5689 13.1065 12.7714 13.4665 13.8099 14.1476C15.6158 15.3318 16.6939 17.3209 16.6939 19.468V22H14.6371V19.468C14.6371 17.0945 12.7055 15.1633 10.332 15.1633H6.36193C3.98793 15.1633 2.05679 17.0945 2.05679 19.468V22Z",
    fill: "#2B00E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPersona);
export default __webpack_public_path__ + "static/media/icon-persona.914adbe43205b0d4d01eee407555a826.svg";
export { ForwardRef as ReactComponent };